import React from "react";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import RebelVillaForm from "./rebel-villa-form";

const RebelSettingsEdit = (props) => {
    let {experience} = useParams();

    return (
        <PageContainer>
            <RebelVillaForm id={experience} client={props.client}/>
        </PageContainer>
    )
}

export default RebelSettingsEdit;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;
